import { Component, Input, TemplateRef } from '@angular/core';
import { ContactUsService } from '../service/ContactUs.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormsService } from 'src/app/shared/service/forms.service';
import { ToastService } from 'src/app/shared/service/toast.service';
@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent {
  contactData: any =[];
  @Input() logoData :any ;

  options: any;

  contactForm!:FormGroup
  constructor(
    private _ContactUsService:ContactUsService,
    private _FormsService:FormsService,
    private toastService: ToastService
  ){
    this._ContactUsService.watch().valueChanges.subscribe((result:any)=>{
 
      if((result != undefined)&&(result['data']['queryContactUsContents']?.length>0)){
        this.contactData = result['data']['queryContactUsContents'][0];
  
          this.options = {
            mapTypeId: 'hybrid',
            zoomControl: true,
            scrollwheel: true,
            disableDoubleClickZoom: true,
            maxZoom: 20,
            minZoom: 8,
            center: {
              lat: this.contactData?.flatData?.ourLocation?.latitude,
              lng: this.contactData?.flatData?.ourLocation?.longitude
            },
          }
      }
      console.log("conttina", this.contactData)
    });

    this.contactForm = new FormGroup({
      name: new FormControl (''),
      email: new FormControl ('',[Validators.email]),
      message: new FormControl ('')
    });


   


  }



  sendform(){
    this._FormsService.contactUsForm(this.contactForm.value).subscribe((res:any)=>{
      if(res != undefined) {
        this.toastService.showSuccess(`success`);
      }
      
    })
    // this.toastService.showSuccess(`success`);
  }


}
